export const removeFileExtension = (filename: string): string =>
  filename.replace(/\.[^/.]+$/, "");

export const createAssetCode = (
  value: string,
  fallback: "board" | "media"
): string => {
  const code = value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

  return code || fallback;
};

export const createMediaCode = (filename: string): string =>
  createAssetCode(removeFileExtension(filename), "media");

export const createBoardCode = (name: string): string =>
  createAssetCode(name, "board");
